import './styles/app.scss'
import { useEffect, useState } from 'react'
import ReactGA from 'react-ga'
import Footer from './Footer'
import CookieConsentAndAnalytics from './CookieConsent'

const TARGET_TIME = new Date('2026-09-10T09:00:00-07:00').getTime();

function App() {
    ReactGA.initialize('UA-132563689-5')
    const [editions, setEditions] = useState([])
    const [data, setData] = useState([])
    const [view, setView] = useState(false)
    const [viewCrossbell, setViewCrossbell] = useState(false)
    const gameData = {
        path: 'crossbell', // 1 Please input game pathname
        steam: '1668520', // 2 Please input Steam ID if available
    }
    const [crossbellData, setCrossbellData] = useState([])
    const [platformDeluxe, setPlatformDeluxe] = useState('Nintendo Switch™2')
    const [isRevealed, setIsRevealed] = useState(() => Date.now() >= TARGET_TIME);

    useEffect(() => {
        if (isRevealed) return;

        const timeRemaining = TARGET_TIME - Date.now();

        // Set a single timeout for the exact delay instead of polling
        const timer = setTimeout(() => {
        setIsRevealed(true);
        }, timeRemaining);

        return () => clearTimeout(timer);
    }, [isRevealed]);

    useEffect(() => {
        fetch(`https://www.nisamerica.com/api/game/${gameData.path}`)
            .then((response) => {
                if (!response.ok) {
                    throw new Error('Network response was not ok ' + response.statusText)
                }
                return response.json()
            })
            .then((data) => {
                const editions = Object.values(data.game.retailerLinks.map((item) => item.edition))
                const formattedData = data.game.retailerLinks.map((item) => {
                    return {
                        url: item.url,
                        store: item.store,
                        edition: item.edition,
                        platform: item.platform,
                        region: item.region,
                    }
                })
                const sortedData = formattedData.sort((a, b) => a.store.localeCompare(b.store))
                setEditions(editions)
                setData(sortedData)
                console.log(data)
            })
            .catch((error) => {
                console.error('There has been a problem with your fetch operation:', error)
            })
    }, [])
    const FilterRegion = (region, platform) =>
        data.filter((item) => item.region === region && item.edition === 'Deluxe Edition' && item.platform === platform)
    return (
        <div className='App'>
                            <CookieConsentAndAnalytics />

            <div className={`preoder-container ${view && 'visible'}`}>
                <div className='preorder-section'>
                    <h1 className='preorder-title'>The Legend of Heroes: Trails from Zero</h1>
                    <div className='preorder-links zero'>
                        <LinkButton
                            game='Zero'
                            console='PS4™'
                            store='Amazon'
                            link='https://www.amazon.com/Legend-Heroes-Trails-Zero-PlayStation-4/dp/B099TL6FN5'
                        />
                        <LinkButton
                            game='Zero'
                            console='PS4™'
                            store='Amazon (CA)'
                            link='https://www.amazon.ca/Legend-Heroes-Trails-Zero-PlayStation/dp/B099TL6FN5'
                        />
                        <LinkButton
                            game='Zero'
                            console='PS4™'
                            store='GameStop'
                            link='https://www.gamestop.com/video-games/playstation-4/products/the-legend-of-heroes-trails-from-zero---playstation-4/325348.html'
                        />

                        <LinkButton
                            game='Zero'
                            console='PS4™'
                            store='Best Buy'
                            link='https://www.bestbuy.com/site/the-legend-of-heroes-trails-from-zero-playstation-4/6481219.p?skuId=6481219'
                        />
                        <LinkButton
                            game='Zero'
                            console='Nintendo Switch™'
                            store='Amazon'
                            link='https://www.amazon.com/Legend-Heroes-Trails-Zero-Nintendo-Switch/dp/B099TL61TZ/'
                        />
                        <LinkButton
                            game='Zero'
                            console='Nintendo Switch™'
                            store='Amazon (CA)'
                            link='https://www.amazon.ca/Legend-Heroes-Trails-Nintendo-Switch/dp/B099TL61TZ/'
                        />

                        <LinkButton
                            game='Zero'
                            console='Nintendo Switch™'
                            store='BestBuy'
                            link='https://www.bestbuy.com/site/the-legend-of-heroes-trails-from-zero-deluxe-edition-nintendo-switch/6481218.p?skuId=6481218'
                        />

                        <LinkButton
                            game='Zero'
                            console='PC'
                            store='Steam'
                            link='https://store.steampowered.com/app/1668510/The_Legend_of_Heroes_Trails_from_Zero/'
                        />
                        <LinkButton
                            game='Zero'
                            console='PC'
                            store='Epic Games Store'
                            link='https://store.epicgames.com/en-US/p/the-legend-of-heroes-trails-from-zero'
                        />
                        <LinkButton
                            game='Zero'
                            console='PC'
                            store='GOG'
                            link='https://www.gog.com/en/game/the_legend_of_heroes_trails_from_zero'
                        />
                    </div>
                </div>
                <div className='preorder-section'>
                    <h1 className='preorder-title'>The Legend of Heroes: Trails to Azure</h1>
                    <div className='preorder-links azure'>
                        <LinkButton
                            game='Azure'
                            console='Nintendo Switch™'
                            store='Amazon'
                            link='https://www.amazon.com/Legend-Heroes-Trails-Azure-Nintendo-Switch/dp/B09B1QVNT6'
                        />
                        <LinkButton
                            game='Azure'
                            console='Nintendo Switch™'
                            store='Amazon (CA)'
                            link='https://www.amazon.ca/Legend-Heroes-Trails-Nintendo-Switch/dp/B09B1QVNT6/'
                        />
                        <LinkButton
                            game='Azure'
                            console='Nintendo Switch™'
                            store='GameStop'
                            link='https://www.gamestop.com/video-games/products/the-legend-of-heroes-trails-to-azure---nintendo-switch/325358.html?bt=truhttps://www.gamestop.com/video-games/nintendo-switch/products/the-legend-of-heroes-trails-to-azure---nintendo-switch/390871.html'
                        />

                        <LinkButton
                            game='Azure'
                            console='Nintendo Switch™'
                            store='Best Buy'
                            link='https://www.bestbuy.com/site/the-legend-of-heroes-trails-to-azure-nintendo-switch/6481233.p?skuId=6481233'
                        />
                        <LinkButton
                            game='Azure'
                            console='Nintendo Switch™'
                            store='Walmart'
                            link='https://www.walmart.com/ip/The-Legend-of-Heroes-Trail-to-Azure-Deluxe-Edition-Nintendo-Switch/901905779'
                        />
                        <LinkButton
                            game='Azure'
                            console='PS4™'
                            store='Amazon'
                            link='https://www.amazon.com/Legend-Heroes-Trails-Zero-Nintendo-Switch/dp/B099TL61TZ/'
                        />
                        <LinkButton
                            game='Azure'
                            console='PS4™'
                            store='Amazon (CA)'
                            link='https://www.amazon.ca/Legend-Heroes-Trails-Nintendo-Switch/dp/B099TL61TZ/'
                        />
                        <LinkButton
                            game='Azure'
                            console='PS4™'
                            store='GameStop'
                            link='https://www.gamestop.com/video-games/products/the-legend-of-heroes-trails-to-azure---playstation-4/325355.html?bt=true'
                        />

                        <LinkButton
                            game='Azure'
                            console='PS4™'
                            store='BestBuy'
                            link='https://www.bestbuy.com/site/the-legend-of-heroes-trails-to-azure-playstation-4/6481232.p?skuId=6481232'
                        />
                        <LinkButton
                            game='Azure'
                            console='PS4™'
                            store='Walmart'
                            link='https://www.walmart.com/ip/The-Legend-of-Heroes-Trails-to-Azure-Deluxe-Edition-PlayStation-4/613736772'
                        />
                    </div>
                </div>
                <div className='preorder-button'>
                    <button
                        onClick={() => {
                            setView(false)
                        }}
                    >
                        Close
                    </button>
                </div>
            </div>
            <div className={`preoder-container ${viewCrossbell && 'visible'}`}>
                <div className='preorder-section'>
                    <h1 className='crossbell-title'>Crossbell Bundle</h1>
                    <h1 className='preorder-title' style={{marginTop: '25px'}}>Limited Edition</h1>{' '}
                    <div className='crossbell-le-links'>
                        <ButtonRetailer
                            dataPlatform='PlayStation®5'
                            dataUrl='https://store.nisamerica.com/products/crossbell-limited-edition'
                            dataStore='NISA Online'
                            gaCategory='Product'
                            gaLabel='NA - Deluxe Edition - PlayStation®5 - NISA Online'
                        />
                        <ButtonRetailer
                            dataPlatform='Nintendo Switch™2'
                            dataUrl='https://store.nisamerica.com/products/crossbell-limited-edition?variant=43053256015920'
                            dataStore='NISA Online'
                            gaCategory='Product'
                            gaLabel='NA - Deluxe Edition - Nintendo Switch™2 - NISA Online'
                        />
                    </div>
                    <p className='preorder-title' style={{marginTop: '25px'}}>Select Platform</p>{' '}
                    <div className='platform-list'>
                        <button
                            className='crossbell-platform nsw2'
                            onClick={() => {
                                setPlatformDeluxe('Nintendo Switch™2')
                            }}
                        >
                            Nintendo Switch™2
                        </button>{' '}
                        <button
                            className='crossbell-platform ps5'
                            onClick={() => {
                                setPlatformDeluxe('PlayStation®5')
                            }}
                        >
                            PlayStation®5
                        </button>
                    </div>
                    <h1 className='preorder-title' style={{marginTop: '25px'}}>Deluxe Edition</h1>{' '}
                    <div className='preorder-links crossbell-le-links zero'>
                        <div>
                            {FilterRegion('NA', platformDeluxe).length > 0 && (
                                <div className=''>
                                    <div className='retailer-buttons'>
                                        {FilterRegion('NA', platformDeluxe).map((data, i) => (
                                            <div key={i}>
                                                <ButtonRetailer
                                                    dataPlatform={data.platform}
                                                    dataUrl={data.url}
                                                    dataStore={data.store}
                                                    gaCategory='Product'
                                                    gaLabel={`NA - Deluxe Edition - ${data.platform} - ${data.store}`}
                                                />
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            )}
                        </div>
                        <div>
                            {FilterRegion('EU', platformDeluxe).length > 0 && (
                                <div className=''>
                                    <div className='captcha-container'>
                                        <h3 className='preorder-title'>Europe</h3>
                                    </div>
                                    <div className='retailer-buttons'>
                                        {FilterRegion('EU', platformDeluxe).map((data, i) => (
                                            <div key={i}>
                                                <ButtonRetailer
                                                    dataPlatform={data.platform}
                                                    dataUrl={data.url}
                                                    dataStore={data.store}
                                                    gaCategory='Product'
                                                    gaLabel={`EU - Deluxe Edition - ${data.platform} - ${data.store}`}
                                                />
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>{' '}
                </div>

                <div className='preorder-button'>
                    <button
                        onClick={() => {
                            setViewCrossbell(false)
                        }}
                    >
                        Close
                    </button>
                </div>
            </div>
            <div className='top-bar'>
                <img src='./img/falcom.png' alt='Falcom Logo' />
                <h1>The Legend of Heroes: Trails from Zero &amp; Trails to Azure </h1>
            </div>
            <div className='game-logos'>
                <div className='logo-pair zero'>
                    <img src={
                        isRevealed ? './img/zero_logo_launch.png' : './img/zero_logo_rda.png'
                    } alt='' />
                    {/* <h1>
                        Coming Fall 2026 to Nintendo Switch™2 and PlayStation®5 <br />Available now on Nintendo Switch™,
                        PlayStation®4, and PC
                    </h1> */}
                    <a
                        href='https://www.thelegendofheroes.com/crossbell/zero/'
                        target='_blank'
                        rel='noopener noreferrer'
                    >
                        <button className='official'>"Trails from Zero" - Official Website</button>
                    </a>
                </div>
                <div className='logo-pair azure'>
                    <img src={
                        isRevealed ? './img/azure_logo_launch.png' : './img/azure_logo_rda.png'
                    } alt='' />
                    {/* <h1>
                        Coming Fall 2026 to Nintendo Switch™2 and PlayStation®5 <br />Available now on Nintendo Switch™,
                        PlayStation®4, and PC
                    </h1> */}
                    <a
                        href='https://www.thelegendofheroes.com/crossbell/azure/'
                        target='_blank'
                        rel='noopener noreferrer'
                    >
                        <button className='official'>"Trails to Azure" - Official Website</button>
                    </a>
                </div>
            </div>

            <div className='video-container'>
                <div className='video-wrapper'>
                    <div
                        style={{
                            position: 'relative',
                            paddingBottom: '56.25%',
                            height: 0,
                            overflow: 'hidden',
                        }}
                    >
                        <iframe
                            style={{
                                position: 'absolute',
                                top: 0,
                                left: 0,
                                width: '100%',
                                height: '100%',
                            }}
                            src={
                                isRevealed ? 'https://www.youtube.com/embed/4vUj0nlTlGA' : 'https://www.youtube.com/embed/XHpTVUikuO0'
                            }
                            frameborder='0'
                            allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
                            allowfullscreen
                            title='Release date announcement trailer'
                        ></iframe>
                    </div>
                </div>
            </div>

            <div className='preorder-button' style={{paddingBottom: '0px'}}>
                <button
                    onClick={() => {
                        setView(true)
                    }}
                >
                    Buy Now for Nintendo Switch™, PlayStation®4, and PC
                </button>
            </div>
            <div className='preorder-button' style={{paddingBottom: '50px', paddingTop: '25px'}}>
                <button
                    onClick={() => {
                        setViewCrossbell(true)
                    }}
                >
                    {isRevealed ? 'Available' : 'Preorder'} Now for Azure and Zero bundle for Nintendo Switch™2, PlayStation®5
                </button>
            </div>
            <div className='specs-container'>
                <div className='spec-wrapper'>
                    <table class='spec-table'>
                        <tbody>
                            <tr>
                                <th>Title</th>
                                <td>The&nbsp;Legend&nbsp;of&nbsp;Heroes:&nbsp;Trails&nbsp;from&nbsp;Zero</td>
                            </tr>
                            <tr>
                                <th>Release</th>
                                <td>
                                    {
                                        isRevealed ?
                                        <>
                                            September 10, 2026 (Nintendo Switch™2 and PlayStation®5)
                                            <br />
                                            March 14, 2023 (Nintendo Switch™, PlayStation®4, and PC)                                    
                                        </> :
                                        <>
                                            September 10 (Nintendo Switch™2 and PlayStation®5)
                                            <br />
                                            Available now (Nintendo Switch™, PlayStation®4, and PC)
                                        </>
                                    }
                                </td>
                            </tr>
                            <tr>
                                <th>Platform</th>
                                <td>Nintendo Switch™2, Nintendo Switch™, PlayStation®5, PlayStation®4. PC</td>
                            </tr>
                            <tr>
                                <th>Player(s)</th>
                                <td>1</td>
                            </tr>
                            <tr>
                                <th>Genre</th>
                                <td>RPG</td>
                            </tr>
                            <tr>
                                <th>Audio</th>
                                <td>Japanese</td>
                            </tr>
                            <tr>
                                <th>Text</th>
                                <td>English</td>
                            </tr>
                            <tr>
                                <th>Developer</th>
                                <td>Nihon Falcom</td>
                            </tr>
                            <tr>
                                <th>Publisher</th>
                                <td>NIS America, Inc.</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div className='spec-wrapper'>
                    <table class='spec-table'>
                        <tbody>
                            <tr>
                                <th>Title</th>
                                <td>The Legend of Heroes: Trails to Azure </td>
                            </tr>
                            <tr>
                                <th>Release</th>
                                <td>
                                    {
                                    isRevealed ?
                                        <>
                                            September 10, 2026 (Nintendo Switch™2 and PlayStation®5) <br />
                                            September 27, 2022 (Nintendo Switch™, PlayStation®4, and PC)
                                        </> :
                                        <>
                                            September 10 (Nintendo Switch™2 and PlayStation®5) <br />
                                            Available now (Nintendo Switch™, PlayStation®4, and PC)                                 
                                        </>
                                    }
                                </td>
                            </tr>
                            <tr>
                                <th>Platform</th>
                                <td>Nintendo Switch™2, Nintendo Switch™, PlayStation®5, PlayStation®4. PC</td>
                            </tr>
                            <tr>
                                <th>Player(s)</th>
                                <td>1</td>
                            </tr>
                            <tr>
                                <th>Genre</th>
                                <td>RPG</td>
                            </tr>
                            <tr>
                                <th>Audio</th>
                                <td>Japanese</td>
                            </tr>
                            <tr>
                                <th>Text</th>
                                <td>English</td>
                            </tr>
                            <tr>
                                <th>Developer</th>
                                <td>Nihon Falcom</td>
                            </tr>
                            <tr>
                                <th>Publisher</th>
                                <td>NIS America, Inc.</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <Footer />
        </div>
    )
}

const LinkButton = ({ game, console, store, link }) => (
    <a
        href={link}
        target='_blank'
        rel='noreferrer'
        onClick={() => {
            ReactGA.event({
                category: 'engagement',
                action: 'generate_lead',
                label: `Purchase - ${game} - ${console} - ${store}`,
            })
        }}
    >
        <button>
            {store} <br />
            {console}
        </button>
    </a>
)
const ButtonRetailer = ({ dataPlatform, dataUrl, dataStore, }) => {
    return (
        <button className={`retailer-button de crossbell-le`}>
            <a
                onClick={() => {
                    ReactGA.event({
                        action: 'click',
                        event: 'link',
                        category: 'Products',
                        label: `DE ${dataPlatform} ${dataStore}`,
                    })
                }}
                target='_blank'
                rel='noreferrer'
                href={`${dataUrl}`}
            >
                <p>{dataStore}</p>
                <h6>{dataPlatform}</h6>
            </a>
        </button>
    )
}

export default App
